import { getRootDomain } from '../links'
import { useSsrContext } from './useSsrContext'

export const useRootDomain = (): string => {
  const { processEnv } = useSsrContext()

  if (processEnv) {
    return getRootDomain(processEnv)
  }

  if (typeof window !== 'undefined' && window.location.origin) {
    return window.location.origin
  }
  return getRootDomain(processEnv)
}
